import { isBookingMultiDayAtom, selectedBookingPackageAtom } from 'components/forms/bookingWidget/jotaiStore';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';
import BookingSelectInput from '../../TimePicker/BookingSelectInput';
import DurationIcon from './DurationIcon';
import { getBoatAvailableOptions } from './utils';

const DurationPicker = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
  onChange = (e) => {},
  defaultValue,
  setter,
  error = null,
  className = null,
  modalVersion = false,
  isMessageOwner = false,
}) => {
  const isBookingMultiDay = useAtomValue(isBookingMultiDayAtom);
  const selectedBookingPackage = useAtomValue(selectedBookingPackageAtom);

  const options = getBoatAvailableOptions(selectedBookingPackage);

  return (
    <DurationPickerWrapper data-testid="pdp-booking-widget-duration-picker-container">
      <BookingSelectInput
        modalVersion={modalVersion}
        setter={setter}
        name="DurationPicker"
        object="duration_picker"
        error={error}
        options={options}
        icon={<DurationIcon />}
        className={className}
        defaultValue={defaultValue}
        onChange={onChange}
        title="Duration"
        height="auto"
        isDisabled={isBookingMultiDay}
        isMessageOwner={isMessageOwner}
      />
    </DurationPickerWrapper>
  );
};

const DurationPickerWrapper = styled.div`
  margin-bottom: 0;
  height: 100%;
`;

export default DurationPicker;
